import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { NumberDecrementStepper, NumberIncrementStepper, NumberInputStepper } from "@chakra-ui/react";

// The theme draws a divider towards the field and gives each stepper `flex: 1`, so the two grow to
// fill the field's height and centre a 12px chevron in a 25px box — which is where the air between
// them comes from, not from the glyphs. Told not to grow, each box hugs its icon and the pair reads
// as one control; the group then centres them.
const STEPPER = {
  border: "none",
  flex: "0 0 auto",
  h: "auto",
  minH: "0",
  p: "0",
  lineHeight: "1",
  my: "-0.5",
} as const;

interface Props {
  /** Chakra marks the group aria-hidden, so the arrows carry no accessible name to find them by. */
  upTestId?: string;
  downTestId?: string;
}

/**
 * The arrows inside a NumberInput, as the rest of the system draws them: chevrons rather than
 * Chakra's triangles, hugging each other instead of spreading over the field's height. Every
 * numeric field that offers steppers should use this one, or they drift apart a pixel at a time.
 */
export const CompactNumberStepper = ({ upTestId, downTestId }: Props) => (
  <NumberInputStepper justifyContent="center">
    <NumberIncrementStepper {...STEPPER} data-testid={upTestId}>
      <ChevronUpIcon />
    </NumberIncrementStepper>
    <NumberDecrementStepper {...STEPPER} data-testid={downTestId}>
      <ChevronDownIcon />
    </NumberDecrementStepper>
  </NumberInputStepper>
);
